import { render, staticRenderFns } from "./FolderSettingsModal.vue?vue&type=template&id=2f745179&scoped=true"
import script from "./FolderSettingsModal.vue?vue&type=script&lang=js"
export * from "./FolderSettingsModal.vue?vue&type=script&lang=js"
import style0 from "./FolderSettingsModal.vue?vue&type=style&index=0&id=2f745179&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f745179",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f745179')) {
      api.createRecord('2f745179', component.options)
    } else {
      api.reload('2f745179', component.options)
    }
    module.hot.accept("./FolderSettingsModal.vue?vue&type=template&id=2f745179&scoped=true", function () {
      api.rerender('2f745179', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/file-browser/modals/FolderSettingsModal.vue"
export default component.exports